import Axios from 'axios';
const RESOURCE_NAME_LOGIN = '/Users/Login';
const RESOURCE_NAME_ADD = '/Users/Add';
const RESOURCE_NAME_USERS = '/Admin/GetUsers';
const RESOURCE_NAME_USER_ACCESS = '/Admin/GetUserAccess/';
const RESOURCE_NAME_USER_ACCESS_SET = '/Admin/AddUsuarioAccesos';
const RESOURCE_ADMIN__SYSTEM = '/Admin/GetSystem/';
const RESOURCE_ADMIN_USER_STATUS = '/Admin/GetUserStatus/';
const RESOURCE_NAME_USERS_EMAIL = '/Admin/GetUsers?email=';

export default {
    login: {
        get(data) {
            return Axios.post(RESOURCE_NAME_LOGIN, data);
        },
        update(data){
            return Axios.post(RESOURCE_NAME_ADD, data);
        }
    },
    admin:{
        getAll(email, status, idsistema) {
            return Axios.get(RESOURCE_NAME_USERS+'?email='+ email +'&status='+status+'&id_sistema='+idsistema);
        },
        post(data){
            return Axios.post(RESOURCE_NAME_USERS, data)
        },
        getUserAccess(id){
            return Axios.get(RESOURCE_NAME_USER_ACCESS + id);
        },
        GetSystem(id){
            return Axios.get(RESOURCE_ADMIN__SYSTEM + id);
        },
        GetUserStatus(id){
            return Axios.get(RESOURCE_ADMIN_USER_STATUS + id);
        },
        GetUserEmail(email){
            return Axios.get(RESOURCE_NAME_USERS_EMAIL + email+'&status=0&id_sistema=0');
        },
        setUserAccess(data){
            return Axios.post(RESOURCE_NAME_USER_ACCESS_SET, data);
        }        
    },
    automotoras:{
        getAll() {
            return Axios.get(RESOURCE_NAME_USERS);
        },
        post(data){
            return Axios.post(RESOURCE_NAME_USERS, data)
        }
    }
};